import { render, staticRenderFns } from "./produits.vue?vue&type=template&id=608669d3"
import script from "./produits.vue?vue&type=script&lang=ts"
export * from "./produits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports